"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReceivableValuationRateEvaluator = exports.checkReceivableValuationRateConfigErrors = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const RequiredIntermediateFields_1 = require("./RequiredIntermediateFields");
/**
 * Receivable valuation rate formulas can use variables from baseFields and intermediate calcs.
 * This functions checks for any missing dependencies found in receivable valuation rate formulas.
 */
const checkReceivableValuationRateConfigErrors = ({ receivableValuationRateConfig, intermediateCalcs, baseFields, }) => {
    const dynamicIntermediateFields = intermediateCalcs
        .map((intermediateCalc) => intermediateCalc.field)
        .filter((field) => !RequiredIntermediateFields_1.RequiredIntermediateFieldNames.includes(field));
    const baseFieldVars = baseFields.map((fieldConfig) => `baseFields.${fieldConfig.field}`);
    const dynamicFieldVars = dynamicIntermediateFields.map((key) => `dynamicIntermediateFields.${key}`);
    const requiredFieldVars = RequiredIntermediateFields_1.RequiredIntermediateFieldNames.map((key) => `requiredIntermediateFields.${key}`);
    const availableVariables = new Set([
        ...baseFieldVars,
        ...dynamicFieldVars,
        ...requiredFieldVars,
    ]);
    (0, common_1.finleyAssert)(receivableValuationRateConfig.type === 'formula', `unknown receivableValuationRateConfig.type:[${receivableValuationRateConfig.type}]`);
    const { errorMessages } = (0, formula_engine_1.getFormulaErrors)(receivableValuationRateConfig.config.formula, availableVariables);
    return errorMessages;
};
exports.checkReceivableValuationRateConfigErrors = checkReceivableValuationRateConfigErrors;
const createReceivableValuationRateEvaluator = (receivableValuationRateConfig, f1EngineMode) => {
    // extract formula from the config.
    // instantiate FormulaEngine with all formula strings
    // we need to do this upfront to ensure that formula's AST are cached.
    (0, common_1.finleyAssert)(receivableValuationRateConfig.type === 'formula', 'keep TS happy');
    (0, common_1.finleyAssert)(receivableValuationRateConfig.config.engineVersion ===
        finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, `${receivableValuationRateConfig.config.engineVersion} is not yet supported`);
    const formulaString = receivableValuationRateConfig.config.formula;
    const formulaEngine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, [formulaString], f1EngineMode);
    const evaluateConfig = (creditFacilityReceivable) => {
        formulaEngine.setVariables(creditFacilityReceivable, { flatten: true });
        return formulaEngine.evaluateNumber(formulaString);
    };
    return {
        evaluateConfig,
    };
};
exports.createReceivableValuationRateEvaluator = createReceivableValuationRateEvaluator;
//# sourceMappingURL=valuationRateEvaluator.js.map